const initialState = {
  tenantList: [],
  loading: false,
  loadError: false,
  filteredTenantList : [],
  isBotOwner : true
}

export default initialState
